<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div :class="resignType == '4' ? 'modal-dialog resign-modal-dialog' : 'modal-dialog'">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 class="modal-title">撥出對象-{{segmentName}}</h3>
        </div>
        <div class="modal-body">
            <section class="search pb-0 mb-4">
                <div class="row">
                    <div class="col-12">
                        <form class="form">
                            <div class="input-group input-lg">
                            <div class="input">
                                <input
                                type="text"
                                name="keyowrd"
                                id="keyowrd"
                                class="form-control"
                                v-model="keyowrd"
                                placeholder="輸入收費代號進行搜尋...">
                            </div>
                            <button
                            class="btn btn-primary btn-icon"
                            type="submit"
                            @click.prevent="doSearch()">
                                <i class="icon-search i-24"></i>
                            </button>
                            </div>
                        </form>
                    </div>
                </div>
            </section>
            <!-- <div v-if="segmentName=='全單位未訪件'">
                <h4>【年份】:
                  <select v-model="years" @change="doSearch"  class="form-control form-control-inline form-wide">
                    <option value="">全部</option>
                    <option
                    v-for="(item, i) in yearsOpt"
                    :key="`item-${i}`"
                    :value="item">
                    <text >{{item}}</text>
                    </option>
                  </select> 年</h4>    
            </div>     -->
            <table class="segment-table table datatable table-striped table-bordered">
                <thead>
                    <tr>               
                        <th width="60px">
                        <div v-if="resignType != '4'" class="checkbox checkbox-inline mr-0">
                            <input 
                            @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                            type="checkbox" 
                            name="check-all" 
                            id="check-all" 
                            value="1" 
                            v-model="checkAll">
                            <label for="check-all"></label>
                        </div>
                        </th>
                        <th width="120px" v-show="segmentCode == 'R'" class="sorting"
                            :class="orderIndex == 'div_short_name' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('div_short_name')">現行單位名稱</th>
                        <th width="90px" v-show="segmentCode == 'R'" class="sorting"
                            :class="orderIndex == 'ceempnm' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('ceempnm')">經理姓名</th>
                        <th width="70px" v-show="segmentCode == 'S'" class="sorting"
                            :class="orderIndex == 'ceempnm' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('ceempnm')">姓名</th>
                        <th width="100px" v-show="segmentCode == 'S'" class="sorting"
                            :class="orderIndex == 'position_name' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('position_name')">職級</th>
                        <th width="70px" v-show="segmentCode == 'S'" class="sorting"
                            :class="orderIndex == 'isnew' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('isnew')">新人</th>
                        <th :width="segmentCode == 'R' ? '110px' : '100px'" class="sorting"
                            :class="orderIndex == 'clcno' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('clcno')">收費代號</th>
                        <th :width="segmentCode == 'R' ? '120px' : '120px'" class="sorting"
                            :class="orderIndex == 'tmp' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('tmp')">服務件數<br>(自招/非自招)</th>                       
                        <th width="90px" class="sorting"
                            :class="orderIndex == 'cs_count' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('cs_count')">要保人數</th>
                        <th width="*" v-show="segmentCode == 'S'" class="sorting"
                            :class="orderIndex == 'apc_count' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('apc_count')">近30日已撥出要保人數</th>
                        <th width="*" v-show="segmentCode == 'R'" class="sorting"
                            :class="orderIndex == 'eff_date' ? (!orderAsc ? 'sorting_asc' : 'sorting_desc') : ''"
                            @click="orderby('eff_date')">收費代號<br>建立日期</th>
                    </tr>
                </thead>
                <tbody v-if="segmentAgntList.length > 0">
                    <tr v-for="(d, did) in sortedAgntList" :key="`td-${did}`">
                        <td width="60px">
                        <div class="mr-0 checkbox checkbox-inline">
                            <input
                            @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                            type="checkbox"
                            name="`td-item[]`"
                            :id="`check-${did}`"
                            :value="d"
                            v-model="selection"
                            :disabled="d === ''"
                            @change="$emit('update', selection)">
                            <label :for="`check-${did}`"></label>
                        </div>
                        </td>
                        <td width="120px" v-show="segmentCode == 'R'">{{d.div_short_name}}</td>
                        <td width="90px" v-show="segmentCode == 'R'">{{d.ceempnm}}</td>
                        <td width="70px" v-show="segmentCode == 'S'">{{d.ceempnm}}</td>
                        <td width="100px" v-show="segmentCode == 'S'">{{d.position_name}}</td>
                        <td width="70px" v-show="segmentCode == 'S'">{{checkIsNew(d.isnew)}}</td>
                        <td :width="segmentCode == 'R' ? '110px' : '100px'">{{d.clcno}}</td>
                        <td :width="segmentCode == 'R' ? '120px' : '120px'">{{d.tmp1}} / {{d.tmp2}}</td>                                              
                        <td width="90px">{{d.cs_count}}</td>
                        <td width="*" v-show="segmentCode == 'S'">{{d.apc_count}}</td>
                        <td width="*" v-show="segmentCode == 'R'">{{d.eff_date}}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td class="empty">
                            <h3 class="text-center py-5">查無資料</h3>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="row">
                <div class="col-12 text-right">
                    <button type="button" @click="$emit('close')" class="btn btn-default">取消</button>
                    <button type="button" @click="$emit('submit', selection)" class="btn btn-primary">加入</button>
                </div>
            </div>
        </div>
      </div>
    </div>

    <resign-modal
        :open="resignModalOpen"
        :cedvno3="cedvno3"
        @close="panelClose('resignModalOpen')"
        @close-all="doCloseAllModal"
    />

    <unlock-resign-modal
        :confirmModalOpen="confirmModalOpen"
        :resignInfo="resignInfo"
        page="manger"
        @close="doCloseUnlockModal"
        @close-all="doCloseUnlockModal"
    />

    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import { commonMixin } from "@/mixins/common";
import { doQueryResignUnlock } from "@/service";
import ResignModal from "@/desktop/components/manager/ResignModal";
import UnlockResignModal from "@/desktop/components/manager/UnlockResignModal";

export default {
    name: 'DialOutPersonModal',
    mixins: [commonMixin],
    components: { ResignModal, UnlockResignModal },
    props: {
        open: {
            type: Boolean,
            default: false
        },
        segmentAgntList: {
            type: Array,
            default: () => {
                return []
            },
        },
        segmentName:{
            type: String,
            default: () => {
                ''
            },
        },
        segmentCode:{
            type: String,
            default: () => {
                ''
            },
        },
        // 1: 專招, 4: 展業
        resignType: {
            type: String,
            default: ""
        }
    },
    watch: {
        open: function () {
            this.updateList()
        },
        // segmentAgntList () {  // 產生全單位未訪件年份下拉選單
        //     let result = []
        //     this.segmentAgntList.forEach(item => {
        //        if(!result.includes(item.code_nm.slice(0,3))) {
        //             result.push(item.code_nm.slice(0,3))
        //        }
        //     })
        //     this.yearsOpt = result.sort().reverse()
        // },
        years: function(){
            this.doSearch();
        }, 
        clickTarget: function(target){
            if(target == 'clickAll' || target == 'clickAll-again') {  //點了全選checkbox
            if(this.checkAll) {  //點了全選
                this.selection = []
                this.agntList.forEach(data => {
                this.selection.push(data)
                });
            } else {  //取消全選
                this.selection = []
            }
            } else {  //點了其他checkbox
            this.checkAll = this.selection.length == this.agntList.length
            }
            this.$emit('update', this.selection)
        },           
    },
    data () {
        return {
            checkAll:false,
            clickTarget:'',
            remoteDataMsg: "資料讀取中，請稍候...",
            keyowrd: '',
            years:'',
            selection: [],
            agntList: [],
            yearsOpt: [],
            resignModalOpen: false,
            cedvno3: "",
            confirmModalOpen: false,
            resignInfo: {},
            orderIndex:'',
            orderAsc: true,
        }
    },
    computed: {
        sortedAgntList() {
            if (!this.orderIndex) return this.agntList;

            const stringFields = ['div_short_name', 'ceempnm', 'position_name', 'isnew', 'clcno', 'eff_date'];
            const isStringField = stringFields.includes(this.orderIndex);

            // 複製新陣列，強迫 Vue 2 觸發響應式更新
            return [...this.agntList].sort((itemA, itemB) => {
                
                // --- 情境 A：服務件數（自招/非自招 tmp1 + tmp2）相加排序 ---
                if (this.orderIndex === 'tmp') {
                    const getSum = (item) => {
                        const t1 = item.tmp1 !== undefined && item.tmp1 !== null && item.tmp1 !== '' ? parseFloat(item.tmp1) : 0;
                        const t2 = item.tmp2 !== undefined && item.tmp2 !== null && item.tmp2 !== '' ? parseFloat(item.tmp2) : 0;
                        const sum = t1 + t2;
                        return isNaN(sum) ? 0 : sum;
                    };
                    return this.orderAsc ? getSum(itemA) - getSum(itemB) : getSum(itemB) - getSum(itemA);
                }

                let valA = itemA[this.orderIndex];
                let valB = itemB[this.orderIndex];

                // --- 情境 B：純文字/字串欄位排序（姓名、職級、收費代號等） ---
                if (isStringField) {
                    valA = valA !== undefined && valA !== null ? String(valA) : '';
                    valB = valB !== undefined && valB !== null ? String(valB) : '';
                    return this.orderAsc 
                        ? valA.localeCompare(valB, 'zh-Hant') 
                        : valB.localeCompare(valA, 'zh-Hant');
                } 
                
                // --- 情境 C：數字或數字字串欄位（要保人數、近30日已撥出人數） ---
                else {
                    if (typeof valA === 'string' && valA.includes('%')) valA = valA.replace('%', '');
                    if (typeof valB === 'string' && valB.includes('%')) valB = valB.replace('%', '');

                    valA = valA !== undefined && valA !== null && valA !== '' ? parseFloat(valA) : 0;
                    valB = valB !== undefined && valB !== null && valB !== '' ? parseFloat(valB) : 0;

                    if (isNaN(valA)) valA = 0;
                    if (isNaN(valB)) valB = 0;

                    return this.orderAsc ? valA - valB : valB - valA;
                }
            });
        }
    },
    methods: {
        doSearch () {
            this.checkAll = false
            this.clickTarget = "clickAll-again"
            this.selection = []
            this.agntList = []
            this.orderIndex = ''
            this.orderAsc = true

            setTimeout(() => {
                this.agntList = this.segmentAgntList.filter(item => {
                    return item.clcno.includes(this.keyowrd) 
                })
                this.registerHanlink()  
            }, 100);
        },
        orderby(indexName) { // 排序表格
            // 點擊表頭時只控制響應式變數狀態，不再手動修改這陣列內部資料
            if (this.orderIndex !== indexName) {
                this.orderIndex = indexName;
                this.orderAsc = true; // 切換新欄位預設正序（可依原專案習慣改為 false）
            } else {
                this.orderAsc = !this.orderAsc; // 同欄位點擊切換正反序
            }
        },
        updateList () {
            this.checkAll = false
            this.selection = []
            this.years = ''
            this.keyowrd = ''
            this.agntList = []
            // 開啟或重新載入視窗時，重置排序變數
            this.orderIndex = ''
            this.orderAsc = true

            const vm = this
            setTimeout(() => {
                vm.agntList = [...vm.segmentAgntList]
                this.registerHanlink()  // 難字 update
            }, 100);
        },
        handleCheckChange(item, event){
             //在區部未訪件(code=S)勾選某一個業務員時，將收費代號前五碼相同的一起勾選起來；取消勾選時，只取消該筆
             const isChecked = event.target.checked;
             if(isChecked){
                if(item.producer_segment == "S"){
                    const prefix = item.clcno ? item.clcno.substring(0, 5) : "";
                    // 找出所有 clcno 前五碼相同的業務員
                    const groupItems = this.agntList.filter(
                        d => d.clcno && d.clcno.startsWith(prefix)
                    );
                    // 更新selection
                    const merged = new Set([...this.selection, ...groupItems]);
                    this.selection = Array.from(merged);
                }
             } else {
                this.selection = this.selection.filter(d => d !== item);
             }
             this.$emit("update", this.selection);
        },
        /**
         * 查詢離退人員清單
         * @param {Object} empData 
         */
        queryResignList(empData) {
            this.selection = [];
            this.selection.push(empData);
            this.cedvno3 = empData.clcno.substring(0, 3);
            this.panelOpen("resignModalOpen");
        },
        checkIsNew(isNew){
            return isNew === 'Y' ? 'V' : ''
        },
        /** 關閉已開啟的modal  */
        doCloseAllModal: function() {
            this.panelClose("resignModalOpen");
            if (this.resignType === "4" || this.resignType === "1") {
                const resignInfo = this.$store.state.resignInfo
                this.selection.forEach(item => item.is_unlock = resignInfo.is_unlock)
            }
            this.$emit("close-resign", this.selection);
        },
        /** 開啟確認視窗 */
        doOpenConfirmModal: function() {
            if (!this.resignInfo.agidno) {
                this.$toast.info({ title: "請選擇離職、退休人員" });
                return;
            }

            if (!this.resignInfo.resign_id && !this.resignInfo.intr_id) {
                this.resignInfo.is_unlock = '';
                this.selection = [];
                this.selection.push(this.resignInfo);
                this.$emit("close-resign", this.selection);
                return;
            }

            doQueryResignUnlock(
                this.$store.state.userInfo.id,
                this.resignInfo.resign_id,
                this.resignInfo.intr_id
            ).then((result) => {
                if (result && result.header.status == "200" && result.body) {
                    if (result.body.is_unlock === "N") {
                        this.panelOpen("confirmModalOpen");
                    } else {
                        this.selection = [];
                        this.resignInfo.is_unlock = 'Y'
                        this.selection.push(this.resignInfo);
                        this.$emit("close-resign", this.selection);
                    }
                }
            });
        },
        /** 關閉確認視窗 */
        doCloseUnlockModal: function() {
            this.panelClose("confirmModalOpen");
            if (this.resignType === "4" || this.resignType === "1") {
                this.selection = [];
                this.selection.push(this.resignInfo);
            }
            this.$emit('close-resign', this.selection);
        }
    }
};
</script>

<style lang="scss" scoped>

.segment-table thead tr,.segment-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.segment-table tbody tr {
  height: 54px;
}

.segment-table tbody {
  display: block;
  height: 300px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;
  
  &::-webkit-scrollbar {
    width: 17px; 
    border: 0;
    box-shadow: none;
  }
  
  &::-webkit-scrollbar-track
  {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #F5F5F5;
  }

  &::-webkit-scrollbar-thumb
  {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}

.resign-modal-dialog {
    width: 1000px !important;
}
</style>